import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setActivityLogsLoading,
    setActivityLogs,
    setActivityLogsError,
} from "../reducers/getActivityLogsReducer";

const getActivityLogs =
    (courseId: string | number, token: string, page: number = 1) => async (dispatch: Dispatch) => {
        dispatch(setActivityLogsLoading(true));
        dispatch(setActivityLogsError(null));

        try {
            const result = await api.get(`courses/${courseId}/activity-logs/?page=${page}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            });

            const data = result?.data;
            const list = Array.isArray(data) ? data : data?.data ?? data?.results ?? data?.logs ?? [];
            const count = data?.count ?? 0;
            dispatch(setActivityLogs({ logs: list, count }));
        } catch (error: any) {
            const message =
                error?.response?.data?.detail ||
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                "Failed to load activity logs.";
            dispatch(setActivityLogsError(message));
        }
    };

export { getActivityLogs };
export { resetActivityLogs } from "../reducers/getActivityLogsReducer";
